/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FieldRadioGroupOptionV1Dto } from './FieldRadioGroupOptionV1Dto';
export type FieldRadioGroupCreateV1Dto = {
  /**
   * Height of the field in pixels
   */
  height?: number;
  /**
   * Name of the field
   */
  name?: string | null;
  /**
   * Page number the field is located on
   */
  page: number;
  /**
   * Type of the field
   */
  type: FieldRadioGroupCreateV1Dto.type;
  /**
   * Width of the field in pixels
   */
  width?: number;
  /**
   * X coordinate of the field on the page in pixels
   */
  x: number;
  /**
   * X coordinate of the field on the page in pixels
   */
  y: number;
  /**
   * UUID of the document the field belongs to
   */
  document_id?: string;
  /**
   * Whether the radio group is optional
   */
  optional: boolean;
  /**
   * Options within the radio group
   */
  radios: Array<FieldRadioGroupOptionV1Dto>;
};
export namespace FieldRadioGroupCreateV1Dto {
  /**
   * Type of the field
   */
  export enum type {
    CHECKBOX = 'checkbox',
    MENTION = 'mention',
    RADIO_GROUP = 'radio_group',
    SIGNATURE = 'signature',
    TEXT = 'text',
  }
}
